import React from 'react'

interface Props {
  threshold?: number
  ref?: React.MutableRefObject<HTMLDivElement>
  rootMargin?: string
  allowUpdate?: boolean
}

export const useIntersected = ({
  threshold = 0.5,
  ref = null,
  rootMargin = '0px',
  allowUpdate = false,
}: Props) => {
  const [isIntersected, setIsIntersected] = React.useState(false)

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting || allowUpdate) {
          setIsIntersected(entry.isIntersecting)
        }
      },
      {
        threshold,
        root: null,
        rootMargin,
      }
    )

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [ref, rootMargin, threshold, allowUpdate])

  return [isIntersected]
}
